import { AppError } from "../errors/index.js";
/**
 * آلة حالة المهمة المباشرة — **معرَّفة، لا مفتوحة**.
 *
 * في v2 كانت الحالات الخمس بلا رسم انتقالات: أي حالة إلى أي حالة. فكان «منجَزة
 * ← مفتوحة» و«معطّلة ← منجَزة» ممكنَين بلا معنى، ولم يكن في الكود موضعٌ واحد
 * يُسأل «هل هذا الانتقال مسموح؟».
 *
 * وهذا الملف هو ذلك الموضع.
 */
export const TASK_STATES = ["open", "in_progress", "blocked", "done"];
/**
 * **الحالاتُ التي تُعدّ شغلاً قائماً** — يخرج منها «منجَز» وحده.
 *
 * وكانت للكروت وحدها (`isCardOpenWork`)، **والمهامُّ تُقاس بشرطٍ يُكتب في موضع
 * استعماله**. فكتبتُ في عدّاد الرئيسية «ما ليس `DONE`» مرّتين بيدي — ثالثةً
 * ورابعةً لقاعدةٍ معلَنة. وهذا بالضبط ما يمنعه «تطبيقٌ واحد لكل مفهوم».
 */
export function isTaskOpenWork(state) {
    return state !== "done";
}
/** الانتقالات المسموحة من كل حالة. ما ليس هنا مرفوض — لا مسكوتٌ عنه. */
const ALLOWED = {
    open: ["in_progress", "blocked", "done"],
    in_progress: ["open", "blocked", "done"],
    blocked: ["open", "in_progress"],
    /**
     * **من «منجَزة» لا يخرج إلا بإعادة فتح.**
     *
     * وإعادة الفتح سلطة قسم أو شركة لا سلطة مكلَّف (قرار شادي ٢٠٢٦-٠٩-٢٣): فمن
     * أنجز لا يُعيد فتح ما أنجزه ليخفي تأخيراً أو يُجمّل ترتيبه.
     */
    done: ["in_progress"],
};
/** إعادة الفتح: خروجٌ من «منجَزة». تُفرَض عليها سلطة أعلى في الحارس. */
export function isReopen(from, to) {
    return from === "done" && to !== "done";
}
export function canMove(from, to) {
    return (ALLOWED[from] ?? []).includes(to);
}
/** الحالات التي يمكن الانتقال إليها من هنا — تُبنى منها أزرار الشاشة */
export function movesFrom(from) {
    return ALLOWED[from] ?? [];
}
/**
 * يرفض الانتقال غير المسموح **بكوده**، ويسمّي الحالتين.
 *
 * فمن يرى الرفض يعرف من أين إلى أين، لا «حدث خطأ».
 */
export function assertMove(from, transition) {
    if (!canMove(from, transition.to)) {
        throw new AppError("CONFLICT", {
            context: { rule: "task-transition-not-allowed", from, to: transition.to },
        });
    }
    if (transition.to === "blocked" && transition.reason.trim() === "") {
        throw new AppError("VALIDATION_FAILED", {
            fields: [{ field: "reason", messageKey: "tasks.blockReasonRequired" }],
        });
    }
}
/** اسم الحالة في الشاشة — **مصدر واحد**، فلا يختلف جدولٌ عن بطاقة */
export const TASK_STATE_LABEL = {
    open: "tasks.state.open",
    in_progress: "tasks.state.inProgress",
    blocked: "tasks.state.blocked",
    done: "tasks.state.done",
};
/** أولوية المهمة — ثلاث درجات، ولونها من توكنز الحالات لا من هوية المشتري */
export const TASK_PRIORITIES = ["normal", "high", "critical"];
export const TASK_PRIORITY_LABEL = {
    normal: "tasks.priority.normal",
    high: "tasks.priority.high",
    critical: "tasks.priority.critical",
};
//# sourceMappingURL=state.js.map